import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.inquiryDraft.removeSupplementFromInquiryDraft;
export const removeMedicationFromInquiryDraftIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
